import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFeedbackComponent } from './form-feedback.component';

@NgModule({
  declarations: [FormFeedbackComponent],
  exports: [FormFeedbackComponent],
  imports: [
    CommonModule
  ]
})
export class FormFeedbackModule { }
